// must be a client component
'use client'
import { CSSVariablesResolver } from '@mantine/core'

import colorVariables from '@/utils/styles/colorTokenToCSSVariables'

const resolver: CSSVariablesResolver = () => ({
  variables: {
    ...colorVariables.commonVariables,
  },
  light: {
    ...colorVariables.lightThemeVariables,
  },
  dark: {
    ...colorVariables.darkThemeVariables,
  },
})

export default resolver
